import { gql } from '@apollo/client';

export const GET_SUPPLEMENTS = gql`
  query GetSupplements {
    supplements {
      id
      name
      subtitle
      description
      emoji
      color
      price
      duration
      benefits
      targetChallenges
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const GET_ALL_SUPPLEMENT_ORDERS = gql`
  query GetAllSupplementOrders($limit: Float!, $offset: Float!) {
    allSupplementOrders(limit: $limit, offset: $offset) {
      id
      quantity
      totalPrice
      status
      isPaid
      paidAt
      challengeContext
      recommendationReason
      createdAt
      updatedAt
      user {
        id
        name
        email
        shippingAddress
        shippingCity
        shippingCountry
        shippingNotes
        shippingZipCode
      }
      supplement {
        id
        name
        price
        emoji
      }
    }
  }
`;

export const GET_SUPPLEMENT_ORDER = gql`
  query GetAllSupplementOrders($limit: Float!, $offset: Float!) {
    allSupplementOrders(limit: $limit, offset: $offset) {
      id
      quantity
      totalPrice
      status
      isPaid
      paidAt
      challengeContext
      recommendationReason
      createdAt
      updatedAt
      user {
        id
        name
        email
        shippingAddress
        shippingCity
        shippingCountry
        shippingNotes
        shippingZipCode
      }
      supplement {
        id
        name
        description
        price
        emoji
        benefits
        duration
      }
    }
  }
`;

export const GET_ALL_PAYMENT_TRANSACTIONS = gql`
  query GetAllPaymentTransactions($limit: Float!, $offset: Float!) {
    allPaymentTransactions(limit: $limit, offset: $offset) {
      id
      amount
      currency
      status
      paymentMethod
      provider
      providerTransactionId
      failureReason
      createdAt
      updatedAt
      user {
        id
        name
        email
      }
      order {
        id
        quantity
        totalPrice
        supplement {
          id
          name
          emoji
        }
      }
    }
  }
`;
